<template>
  <AboutDirectSchool :title="title" :locations="locations" :people="people" />
</template>

<script>
import AboutDirectSchool from "@/components/AboutDirectSchool.vue";

export default {
  components: {
    AboutDirectSchool
  },
  data() {
    return {
      title: "西屯校區",
      locations: [
        {
          name: null,
          description: null,
          photo: require("../assets/xitun-photo.png"),
          address: "台中市西屯區上安路41號",
          phone: "04 2700-3389"
        }
      ],
      people: [
        {
          title: "國中部主任",
          photo: require("../assets/xitun-director.png"),
          name: "楊之心"
        },
        {
          title: "國小部主任",
          photo: require("../assets/xitun-elementary-school-director.png"),
          name: "莊皓宇"
        }
      ]
    };
  }
};
</script>

<style></style>
